import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Email: niceavr@gmail.com</p>
          <p>Phone: +91 9346740314</p>
          <p>Address: Vykuntapuram,Kavali, Andra Pradesh</p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#courses">Courses</a>
        </div>
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a href="#">Facebook</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 NICE COMPUTER EDUCATION. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
